import { create } from 'zustand';

import { api, type AdminUser, setCsrfToken } from '../services/api';

interface AuthState {
  user: AdminUser | null;
  loading: boolean;
  error: string | null;
  bootstrap: () => Promise<void>;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
}

export const useAuth = create<AuthState>((set) => ({
  user: null,
  loading: false,
  error: null,
  bootstrap: async () => {
    set({ loading: true, error: null });
    try {
      const status = await api.status();
      if (status.loggedIn && status.admin) {
        if (status.csrfToken) setCsrfToken(status.csrfToken);
        set({ user: status.admin, loading: false });
      } else {
        set({ user: null, loading: false });
      }
    } catch {
      set({ user: null, loading: false });
    }
  },
  login: async (email: string, password: string) => {
    set({ loading: true, error: null });
    try {
      await api.login(email, password);
      const res = await api.me();
      if (res.csrfToken) setCsrfToken(res.csrfToken);
      set({ user: res.admin, loading: false });
    } catch (e: any) {
      set({ error: e?.message || 'Login failed', loading: false });
      throw e;
    }
  },
  logout: async () => {
    set({ loading: true, error: null });
    try {
      await api.logout();
    } finally {
      set({ user: null, loading: false });
    }
  },
}));
